<template>
  <div id="ng" v-pre ng-app="app" class="ng-content">
    <div id="appLoading" ng-class="{ hidden: !isLoading }">
      <img src="/static/ng/images/logo-intelipost.png" alt="Intelipost" />
      <img src="/static/ng/images/loader.gif" alt="Carregando..." />
    </div>

    <div id="app" ng-class="{ show: !isLoading }" class="wrapper hidden">
      <div id="requestOverlay" ng-class="{ active: showRequestOverlay }">
        <i class="fa fa-spinner zoomIn fa-spin fa-3x fa-fw"></i>
      </div>

      <div data-ui-view></div>
    </div>

    <div id="Modal-container" ui-view="modal_container" autoscroll="false"></div>
  </div>
</template>

<script>
  import { ScToast } from '@intelipost-js/secure-components';

  export default {
    beforeCreate() {
      window.$toast = ScToast;
      window.$urls = {
        environment: process.env.NODE_ENV,
        api: `${process.env.API_URL}/api/v1`,
        node_api: process.env.INTELI_PROXY,
        s3_images: `${process.env.S3_ASSETS_URL}images/`,
        bi: process.env.BI_URL,
        ftp: process.env.FTP_URL,
      };
    }
  };
</script>

<style lang="scss">
  @import "./dist/styles/base.css";

  .ng-content {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 13px;

    // Links & BTN's
    a {
      &:not(.btn) {
        color: #002716;
        transition: color .2s;

        &:hover,
        &:focus {
          color: #6d8630;
          text-decoration: underline;
        }
      }
    }

    .btn {
      box-shadow: none;
      border: 1px solid transparent;
      transition: all .2s;

      &:focus {
        box-shadow: 0 0 3px 1px #002716;
      }

      &.btn-default {
        color: #09A83D;
        background-color: #E5FAEB;
        border-color: #09A83D;

        &:hover {
          background-color: darken(#E5FAEB, 10%);
          border-color: darken(#09A83D, 10%);
        }
      }

      &.btn-primary,
      &.btn-success {
        color: #fff;
        background-color: #002716;
        border-color: #002716;

        &:hover {
          background-color: darken(#002716, 10%);
          border-color: darken(#002716, 10%);
        }
      }

      &.btn-warning {
        color: #fff;
        background-color: #f0ad4e;
        border-color: #eea236;

        &:hover {
          background-color: darken(#f0ad4e, 10%);
          border-color: darken(#eea236, 10%);
        }
      }

      &.btn-info {
        color: #fff;
        background-color: #5bc0de;
        border-color: #46b8da;

        &:hover {
          background-color: darken(#269abc, 5%);
          border-color: darken(#1b6d85, 5%);
        }
      }

      &.btn-danger {
        color: #fff;
        background-color: #e84c3d;
        border-color: #e53726;

        &:hover {
          background-color: darken(#e84c3d, 10%);
          border-color: darken(#e53726, 10%);
        }
      }

      &.conditionSwitch {
        color: #444;
        background-color: #FAFAFA;

        &.active {
          box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.3) inset;
          background-color: #f1f1f1;
        }
      }
    }

    .eventsRuleslayer {
      top: 0;

      @media (min-width: 1200px) {
        left: calc(50% - 110px);
      }

      form {
        .btn {
          &.btn-default {
            transition: all ease .2s;

            &.active {
              color: #fff;
              background-color: #002716;
              border-color: #002716;
            }
          }
        }
        .radio {
          + .radio {
            margin-left: 0;
          }
        }
      }

      .accordion-wrap {
        + .accordion-wrap {
          margin-top: 15px;
        }
      }
    }

    .selectedCondition {
      .delete {
        color: transparent;
        top: 0;
        bottom: 0;
        margin: auto;
        background-color: #EEE;
        transition: background .2s;

        &:hover,
        &:focus {
          background-color: (#DDD, 10);
        }
      }
    }

    // Typography
    h1 {
      font-size: 2.2em;
      font-weight: 300;
      color: #002716;
    }

    h2 {
      font-size: 1.9em;
    }

    h1, .h1, h2, .h2, h3, .h3 {
      margin-top: 20px;
      margin-bottom: 10px;
    }

    .title {
      font-size: 100%;

      &header {
        margin-bottom: 10px;
      }
    }

    // Tables
    td, th {
      text-align: inherit;
      word-wrap: initial;

      &.text-right {
        text-align: right;
      }
    }

    table td, table th {
      vertical-align: inherit;
    }

    .tableWrap {
      overflow-y: inherit;
      overflow-x: auto;
    }

    .table {
      > thead {
        tr {
          td, th {
            border-width: 1px 1px 2px;
          }

          > th {
            &:first-child {
              border-left: 2px solid #ddd;
            }

            &:last-child {
              border-left: 2px solid #ddd;
            }

            &.sort {
              &:hover {
                background-color: #f5f5f5;
              }
            }
          }
        }
      }

      > tbody {
        > tr {
          > th,
          > td {
            border-bottom-width: 1px;
          }
        }
      }

      tfoot {
        > th,
        > td {
          border-width: 1px 1px 0px;
        }
      }

      &.quotationRulesTable {
        > tbody {
          > tr {
            > th,
            > td {
              .btn {
                &.providerLogo {
                  width: auto;
                }
              }
            }
          }
        }
      }
    }

    .transactionDetail {
      td {
        &.volumeId {
          width: 100px;

          &.col-xs-3 {
            width: 18.75%;
          }

          &.col-xs-6 {
            width: 37.5%;
          }
        }

        .vat {
          text-align: left;
        }

        .tooltip {
          width: 210px;
        }
      }
    }

    // Components
    .navbar {
      display: block;
    }

    .nav-tabs {
      > li {
        > a {
          &:hover {
            text-decoration: none;
          }
        }
      }
    }

    .pagination {
      a {
        &:not(.btn) {
          color: inherit;

          &:hover,
          &:focus {
            color: #FFF;
            text-decoration: none;
            cursor: default;
          }
        }
      }
    }

    .tooltip {
      position: absolute;

      &:after {
        box-shadow: none;
      }
    }

    .ui-select-match {
      width: 100%;
    }

    .daterange_with_clean {
      border-color: #cccccc;

      .delete {
        color: transparent;
        background: #EEE;
        top: 0;
        bottom: 0;
        right: 5px;
        margin: auto;
        transition: background .2s;

        &:after,
        &:before {
          background-color: #9f9f9f;
        }

        &:hover,
        &:focus {
          color: transparent;

          &:after,
          &:before {
            background-color: #002716;
          }
        }
      }
    }

    .dropdown-menu {
      > li {
        > a {
          color: #333333;

          &:hover {
            color: #262626;
            text-decoration: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-ng/Ng.vue